<script>
    export default {
        props: {
            to: {
                type: Object,
                default: null
            },
            shrink: {
                type: Boolean,
                default: false
            },
            wrap: {
                type: Boolean,
                default: false
            }
        },
        render (createElement) {
            return createElement('router-link', {
                class: [
                    'table-cell',
                    'border-b border-grey-lightest',
                    'px-4',
                    'py-3',
                    'leading-tight',
                    'first-child:pl-6',
                    'last-child:pr-6',
                    'align-top',
                    'no-underline',
                    'text-inherit',
                    'hover:text-blue',
                    ...(this.wrap ? ['whitespace-wrap'] : ['whitespace-no-wrap']),
                    ...(this.shrink ? ['w-px'] : [])
                ].join(' '),
                attrs: {
                    to: this.to
                }
            }, [
                this.$slots.default,
                this.$slots.secondary
                    ? createElement('div', {
                        class: [
                            'text-sm',
                            'text-grey-darker'
                        ].join(' ')
                    }, this.$slots.secondary)
                    : null
            ])
        }
    }
</script>
